import React, { useEffect, useState, useRef } from "react";
import ReactToPrint from 'react-to-print';
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Portal,
  Progress,
  SimpleGrid,
  Spacer,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Text,
  Th,
  Tr,
  Td,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  FormControl,
  FormLabel,
  Select,
  VStack,
  Menu,
  MenuButton,
  MenuList,
  Switch,
  HStack,
} from "@chakra-ui/react";
// assets
import peopleImage from "assets/img/people-image.png";
import logoChakra from "assets/svg/logo-white.svg";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";
// Custom icons
import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  RocketIcon,
  StatsIcon,
  WalletIcon,
  PersonIcon
} from "components/Icons/Icons.js";
import { BellIcon, SearchIcon, SettingsIcon } from "@chakra-ui/icons";
import DashboardTableRow from "components/Tables/DashboardTableRow";
import TimelineRow from "components/Tables/TimelineRow";
import useGetOrdersMechanicReports from "hooks/useGetOrdersMechanicReports";
import EasyChekLogo from "assets/images/easychek_logo.jpg";
import "assets/css/print.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/easychek.css";
import useGetMechanics from "hooks/useGetMechanics";

// react icons
export default function MechanicsReport() {
  let navbarIcon = useColorModeValue("gray.500", "gray.200");

  const [ mechanicIds, setMechanicIds ] = useState([]);
  const [ startDate, setStartDate ] = useState(new Date());
  const [ endDate, setEndDate ] = useState(new Date());
  const printableComponentRef = useRef();
  const [ filter, setFilter ] = useState('all');
  const [ completed, setCompleted ] = useState(null);
  const [ textSize, setTextSize ] = useState("x-small");
  const [ visibleColumns, setVisibleColumns ] = useState({
    // "Mechanic": true,
    "Customer": true,
    "Plate No.": true,
    "Labor": true,
    // "Parts": true,
    // "Discount": true, 
    // "Net Sales": true,
    // "Cash": true,
    // "Online": true,
    // "A/R Paid": true,
    // "A/R": true,
    // "Cheque": true,
  });


  let {
    mechanics, 
    totalMechanics, 
    gettingMechanics, 
    setGettingMechanics, 
    gettingMechanicsReqSuccess
  } = useGetMechanics({
    page: 1,
    limit: 5000, 
  });

  let {
    orders, 
    gettingOrders, 
    setGettingOrders, 
    gettingOrdersReqSuccess,
  } = useGetOrdersMechanicReports({
    mechanicIds: mechanicIds,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    completed: completed, 
  });
  const [ shownOrders, setShownOrders ] = useState([]);



  const value = "$100.000";
  // Chakra Color Mode
  const { colorMode, toggleColorMode } = useColorMode();
  const iconTeal = useColorModeValue("teal.300", "teal.300");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");


  const onChangeVisibleColumn = (columnName, value) => {
    const tmp = {...visibleColumns};
    tmp[columnName] = value;
    setVisibleColumns(tmp);
    // console.log(columnName, value);
  }

  useEffect(() => {

    const tmpList = [];
    orders.forEach((v, i) => {
      // console.log(v.mechanics, mechanicIds);
      // console.log(v.mechanics.filter(fv => fv.id == mechanicIds[0]));
      if (mechanicIds.length == 1) {
          tmpList.push({
            ...v,
            mechanic: v.mechanics.filter(fv => fv.mechanicId == mechanicIds[0])[0],
          })
      } else {
          v.mechanics.forEach((mv, mi) => {
              tmpList.push({
                ...v,
                mechanic: mv,
              })
          })
      }
    });

    console.log(tmpList);
    setShownOrders(tmpList);

  }, [orders]);


  useEffect(() => {
    setGettingMechanics(true);
  }, []);

  const countColSpan = () => {
    let span = 1;
    span += visibleColumns["Customer"] ? 1:0;
    span += visibleColumns["Plate No."] ? 1:0;
    return span;
  }

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      
      <Grid
        templateColumns={{ md: "3fr", lg: "3fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        my="12px"
        gap="24px"
      >

        <Card 
          p="1.2rem" 
          w="100%"
          h={{ sm: "auto", lg: "auto" }}
          position="relative"
          borderRadius="15px"
        >
          <CardBody w="100%">

            <Flex flexDirection="row">


                  {/* Mechanic */}
                  <FormControl marginLeft={4}>
                      <FormLabel>Mechanic</FormLabel>
                      <Select
                        onChange={(e) => {
                          if (e.target.value == 'All') {
                            setMechanicIds([]);
                          } else {
                            setMechanicIds([e.target.value]);
                          } 
                        }}
                      >
                        <option key="status-all" value="All">All</option>
                        { mechanics.map((m) => {
                          return  <option key={m.id} value={m.id}>{m.firstName} {m.lastName}</option>
                        })}
                    </Select>
                  </FormControl>

                  {/* Start Date */}
                  <FormControl  marginLeft={4}>
                      <FormLabel>Start Date</FormLabel>
                      <DatePicker 
                          className="easychek-date-picker"
                          selected={startDate} onChange={(date) => {
                            const tmp = date;
                            tmp.setHours(0,0,0,0);
                            setStartDate(tmp);
                          }} 
                      />
                  </FormControl>


                  {/* End Date */}
                  <FormControl  marginLeft={4}>
                      <FormLabel>End Date</FormLabel>
                      <DatePicker 
                          className="easychek-date-picker"
                          selected={endDate} onChange={(date) => {
                            const tmp = date;
                            tmp.setHours(23,59,59,999);
                            setEndDate(date);
                          }} 
                      />
                  </FormControl>


                  {/* Complete */}
                  <FormControl marginLeft={4}>
                      <FormLabel>Status</FormLabel>
                      <Select
                        onChange={(e) => {
                          if (e.target.value == 'All') {
                            setCompleted(null);
                          } else if (e.target.value == 'Ongoing') {
                            setCompleted(false);
                          } else if (e.target.value == 'Completed') {
                            setCompleted(true);
                          }
                        }}
                      >
                        <option key="status-all" value="All">All</option>
                        <option key="status-ongoing" value="Ongoing">Ongoing</option>
                        <option key="status-completed" value="Completed">Completed</option>
                    </Select>
                  </FormControl>


                  <FormControl>
                    <FormLabel>&nbsp;</FormLabel>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        // h="45"
                        color="white"
                        marginLeft={4}
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={ gettingOrders } 
                        onClick={() => setGettingOrders(true)}
                    >
                        RELOAD
                    </Button>
                  </FormControl>

            </Flex>

          </CardBody>
        </Card>


      </Grid>


      <Grid
        templateColumns={{ md: "3fr", lg: "3fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        my="12px"
        gap="24px"
      >

        <Card p="1.2rem" 
          w="100%"
          h={{ sm: "auto", lg: "auto" }}
          position="relative"
          borderRadius="15px">
          <CardBody w="100%">
            <Flex flexDirection="column" width="100%">
                
              <Flex flexDirection="row" width="100%" flex>


                {/* <Text fontSize="sm" color="gray.400" fontWeight="bold" mb={4}>
                  DATA RESULT
                </Text> */}

                <HStack ml={2} flex={1} flexGrow={1} flexBasis={0}>
                  {/* <Text marginLeft={2}>Filter</Text>
                  <Select maxWidth={240}
                    defaultValue={"all"}
                    onChange={(e) =>  setFilter(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="paidCash">Paid By Cash</option>
                    <option value="paidOnline">Paid Online</option>
                    <option value="paidAccountsReceivable">Paid Accounts Receivable</option>
                    <option value="paidCheque">Paid By Cheque</option>
                  </Select> */}
                </HStack>
                
                <Box textAlign="center" flex={1} flexGrow={1} flexBasis={0}>
                  <ReactToPrint
                    trigger={() => <Button
                      maxWidth="120px"
                      fontSize="10px"
                      type="submit"
                      bg="teal.300"
                      color="white"
                      marginLeft={4}
                      _hover={{
                      bg: "teal.200",
                      }}
                      _active={{
                      bg: "teal.400",
                      }}
                      disabled={ shownOrders.length == 0 }
                      >Print this out!</Button>}
                      content={() => printableComponentRef.current}
                  />
                </Box>


                <Box textAlign="right" flex={1} flexGrow={1} flexBasis={0}>
                  <Menu flex={1} >
                    <MenuButton>
                      <SettingsIcon color={navbarIcon} w="24px" h="24px" />
                    </MenuButton>
                    <MenuList p="16px 8px" width="80px">
                      <Flex flexDirection="column">
                        { Object.keys(visibleColumns).map((key) => {
                            return (
                              <FormControl display="flex" key={`control-key-${key}`}
                                alignItems="center" >
                                <FormLabel htmlFor={key} mb="0"
                                width="100%">
                                  {key}
                                </FormLabel>
                                <Switch id={key} defaultChecked={visibleColumns[key]}
                                  onChange={e => onChangeVisibleColumn(key, e.target.checked)}/>
                              </FormControl>
                            )
                          })
                        }
                        <FormControl display="flex" marginTop="4px">
                          <FormLabel flex={1}>Font Size</FormLabel>
                          <Select defaultValue={textSize} fontSize="xs" 
                          maxWidth={120}
                            onChange={(e) => setTextSize(e.target.value)}>
                              <option value="small">Normal</option>
                              <option value="x-small">Small</option>
                              <option value="xx-small">X-Small</option>
                          </Select>
                        </FormControl>
                      </Flex>
                    </MenuList>
                  </Menu>
                </Box>

              </Flex>
              
        
              <Box width={"100%"} 
                  // direction="column"
                  alignSelf="center"
                  justifySelf="center"
              >
                  <VStack >
                    <Flex
                      flex={1}
                      direction="column"
                      alignSelf="center"
                      justifySelf="center"
                      justifyContent="center"
                      width={"99%"} 
                      m="4px"
                      mt="10px"
                      ref={printableComponentRef}>
                      {/** Logo and Header */}
                      <Flex 
                          direction="row"
                          textAlign="center"
                          justifyContent="center"
                          align="center"
                          mt="4px"
                          mb="12px"
                          display="none"
                          className="show-print"
                      >
                          <Image
                            // boxSize="100px"
                            width={"120px"}
                            objectFit="fit"
                            src={EasyChekLogo}
                            alt="Easy Chek 7 Logo"
                          />
                          <Flex direction={"column"}>
                              <Text 
                                  fontSize="22px"
                                  color={"black"}
                                  fontWeight="bold"
                                  textAlign="center"
                              >
                                  EASY CHEK 7 AUTO SERVICE CORP.
                              </Text>
                              <Text
                                  fontSize="xs"
                                  textAlign="center"
                              >
                                  14-5 FIL AM ROAD CUTCUT ANGELES CITY PAMPANGA
                              </Text>
                              <Text
                                  fontSize="xs"
                                  textAlign="center"
                              >
                                  CONTACT NO. 0917631-8628(GLOBE) AND 0943-706-0855(SMART)
                              </Text>
                          </Flex>
                      </Flex>

                      <style type="text/css" media="print">{"\
                        @page {\ size: A4 landscape;\ }\
                      "}</style>

                      <Box 
                        display="block"
                        overflowX="auto">

                        <Table variant="simple" 
                          color={textColor} 
                          className="table-print"
                        >
                          <Thead>
                            <Tr my=".8rem" p={2} color="gray.400">
                            
                              <Th p={2} color="gray.400" fontSize={textSize}>MECHANIC</Th>
                                
                              { visibleColumns["Customer"]
                                ? <Th p={2} color="gray.400" fontSize={textSize}>CUSTOMER</Th> 
                                : null }
                              { visibleColumns["Plate No."]
                                ? <Th p={2} color="gray.400" fontSize={textSize}>PLATE No.</Th>
                                : null }
                              { visibleColumns["Labor"]
                                ? <Th p={2} color="gray.400" fontSize={textSize}>TOTAL LABOR</Th>
                                : null }
                            </Tr>
                          </Thead>
                          <Tbody>
                            {gettingOrders ? 
                              <Tr my=".8rem">
                                <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                                  <Progress isIndeterminate />
                                </Td>
                              </Tr>
                              : shownOrders.length > 0 
                                ? shownOrders.map((o) => {
                                  return (
                                    <Tr my=".8rem" p={2} key={`tbl-row-${o.id}-${o.mechanic.id}`}>
                                      
                                      <Td  p={2} fontSize={textSize}>
                                          { o.mechanic
                                            ? o.mechanic.fullName
                                            : null
                                          }
                                      </Td>

                                      { visibleColumns["Customer"]
                                        ?  <Td p={2} fontSize={textSize}>
                                          {o.customer.companyName 
                                            ? o.customer.companyName
                                            : `${o.customer.firstName} ${o.customer.lastName}`
                                          }
                                        </Td>
                                      : null 
                                      }
                                      { visibleColumns["Plate No."]
                                        ?  <Td  p={2} fontSize={textSize}>{o.carPlate}</Td>
                                        : null 
                                      } 
                                      { visibleColumns["Labor"]
                                        ? <Td  p={2} fontSize={textSize}>{Number(o.laborTotal).toLocaleString()}</Td>
                                        : null 
                                      }
                                      
                                    </Tr>
                                  );
                                })
                                : <Tr my=".8rem" p={2}>
                                  <Td>No Result</Td>
                                </Tr>
                            }
                          </Tbody>

                          { shownOrders.length > 0 
                              ? <Tfoot>
                                  <Tr>
                                    <Td p={2} fontSize={textSize}
                                      textAlign="right"
                                      fontWeight="bold"
                                      colSpan={countColSpan()}>TOTAL</Td>
                                    { visibleColumns["Labor"]
                                      ?  <Td p={2} fontSize={textSize} >₱{ 
                                          Number(shownOrders.reduce((n, {laborTotal}) => 
                                            n + parseFloat(laborTotal), 0)
                                          ).toLocaleString()}
                                        </Td>
                                      : null 
                                    }
                                    
                                  </Tr>
                                </Tfoot>
                              : null
                            }
                        </Table>
                      </Box>
                     
                    </Flex>
                  </VStack>
              </Box>
            </Flex>
          </CardBody>
        </Card>

      </Grid>


    </Flex>
  );
}
